import { render, staticRenderFns } from "./EduPositionSingleSelection.vue?vue&type=template&id=7fbe0e96&"
import script from "./EduPositionSingleSelection.vue?vue&type=script&lang=ts&"
export * from "./EduPositionSingleSelection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports